import styled from "styled-components";
import { View, Text, TouchableOpacity } from "react-native";
import * as React from "react";

interface SegmentsTabProps<T> {
  tabs: Array<T | " ">;
  selected?: T;
  onSelect: (tab: T) => void;
}

const Label = styled(Text)<{ selected: boolean }>`
  font-weight: ${props => (props.selected ? "bold" : "500")};
`;

const Cell = styled(TouchableOpacity)<{ selected: boolean }>`
  padding: 10px;
  margin: 0 10px;
  border-bottom-width: 3px;
  border-bottom-color: ${props => (props.selected ? "green" : "transparent")};
`;

const Container = styled(View)`
  flex-direction: row;
`;

const SegmentsTab = <T extends any>(props: SegmentsTabProps<T>) => {
  return (
    <Container>
      {props.tabs.map(tab =>
        tab === " " ? (
          <View key=" " style={{ flexGrow: 1 }} />
        ) : (
          <Cell
            key={String(tab)}
            selected={tab === props.selected}
            onPress={() => props.onSelect(tab)}
          >
            <Label selected={tab === props.selected}>{tab}</Label>
          </Cell>
        )
      )}
    </Container>
  );
};

export default SegmentsTab;
